"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stableSort = function (data, comparator) {
    var dataWithIndex = data.map(function (element, index) { return ({ element: element, index: index }); });
    var stableComparator = function (a, b) {
        var result = comparator(a.element, b.element);
        if (!result) {
            result = a.index - b.index;
        }
        return result;
    };
    var sorted = dataWithIndex.sort(stableComparator);
    return sorted.map(function (withIndex) { return withIndex.element; });
};
exports.default = stableSort;
//# sourceMappingURL=stableSort.js.map